var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderIDicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.59998V11.4C10.6667 13.7333 9.73337 14.6666 7.40004 14.6666H4.60004C2.26671 14.6666 1.33337 13.7333 1.33337 11.4V8.59998C1.33337 6.26665 2.26671 5.33331 4.60004 5.33331H7.40004C9.73337 5.33331 10.6667 6.26665 10.6667 8.59998Z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 1.33331H8.59984C6.29984 1.33331 5.36651 2.24665 5.33984 4.49998H7.39984C10.1998 4.49998 11.4998 5.79998 11.4998 8.59998V10.66C13.7532 10.6333 14.6665 9.69998 14.6665 7.39998V4.59998C14.6665 2.26665 13.7332 1.33331 11.3998 1.33331Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIDicon);
export default __webpack_public_path__ + "static/media/orderIDicon.48c49102fba33f465e88561ee7640747.svg";
export { ForwardRef as ReactComponent };